import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import PropTypes from "prop-types";
import clsx from "clsx";
import * as Yup from "yup";
import axios from "src/utils/axios";
import { Formik } from "formik";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useSnackbar } from "notistack";
import useIsMountedRef from "src/hooks/useIsMountedRef";
import {Autocomplete, Box, Button, FormHelperText, Grid, Stack, TextField, Typography, } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { createCategory, updateCategory, deleteCategory, } from "src/actions/mgmtCategoryAction";
import { fetchCategory, getCategoryDropdownList} from "src/actions/mgmtSelectValueAction";
import { IMAGE_TYPE, IMAGE_BASE_URL } from "src/config";
import ImageEditor from "src/components/ImageEditor";
import ConfirmBox from "./ConfirmBox";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
const useStyles = makeStyles(() => ({
  root: {},
   editor: {
    "& .ql-editor": {
       height: 400,
       },
      },
    }));

function CategoryForm({ customerId, categoryInfo, parentCategoryNames,parentCategoryName,isNewCategory, onSubmitSuccess, onSubmitCancel, className, ...rest }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isDeleteOpen, setDeleteOpen] = useState(false);
   const [image, setImage] = useState("");
   const [bannerImage, setBannerImage] = useState("");
   const [bannerPreview, setBannerPreview] = useState("");
   function handleImage(e) {
    // console.log(e.target.files)
  setImage(e.target.files[0]);
}
function handleBannerImage(e) {
  const file = e.target.files[0];
  setBannerImage(file);
  if (file) {
    setBannerPreview(
      URL.createObjectURL(file)
    );
  }
}

const imageUrl = `${IMAGE_BASE_URL}/${categoryInfo?.categoryImage}`;
const bannerImageUrl =
  categoryInfo?.bannerURLs?.length > 0
    ? `${IMAGE_BASE_URL}/${categoryInfo.bannerURLs[0]}`
    : "";
// console.log("CategoryForm: imageUrl: ", imageUrl, categoryInfo, parentCategoryNames);

const { enqueueSnackbar } = useSnackbar();
const account = useSelector((state) => state.account);
const addedBy = account.user.email;

console.log("DEBUG → parentCategoryName:", parentCategoryName);
console.log("DEBUG → isNewCategory:", isNewCategory);

useEffect(() => {}, [categoryInfo, isNewCategory]);

function handleDeleteOpen() {
   setDeleteOpen(true);
   // Call delete action
}
const [categories, setCategories] = useState([]);
const [ondcCategoryId, setOndcCategoryId] = useState("");
const [domain, setDomain] = useState("");
const [categoryId, setCategoryId] = useState("");



useEffect(() => {
   const fetchCategories = async () => {
    try {
       const response = await dispatch(getCategoryDropdownList());
       console.log("ONDC API response:", response);
       const list = response?.data?.category || [];
       console.log("Categories for dropdown:", list);
       setCategories(list);
       } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

  fetchCategories();
}, [dispatch]);

useEffect(() => {
  if (bannerImageUrl) {
    setBannerPreview(bannerImageUrl);
  } else {
    setBannerPreview("");
  }
}, [bannerImageUrl]);


async function handleDeleteCategory(customerId, categoryId) {
   // console.log("Deleting Category: ", customerId, categoryId);
   setDeleteOpen(false);
   try {
     await dispatch(deleteCategory(customerId, categoryId));
     enqueueSnackbar("Deleted Category Successfully", {
       variant: "success",
     });
     await dispatch(fetchCategory(customerId));
     onSubmitSuccess();
   } catch (err) {
       // console.log("Error Delete: ", err);
      enqueueSnackbar("Failed to delete category " + err?.message, {
         variant: "failure",
      });
    }

  }

 // if(isNewCategory) {
  //     parentCategoryNames?.push(categoryInfo?.name);
  // }

   return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        customerId: customerId,
        categoryId: categoryInfo?.categoryId || "",
        name: categoryInfo?.name || "",
        parentCategory: isNewCategory
          ? parentCategoryName || ""
          : categoryInfo?.parentCategory || "",
        description : categoryInfo?.description || "",
        categoryImage:  categoryInfo?.categoryImage,
        domain:
              categoryInfo?.ondcCategory?.name ||
              categoryInfo?.domain || "",
        ondcCategoryId:
           categoryInfo?.ondcCategory?.id ||
           categoryInfo?.ondcCategoryId || "",

     }}
      validationSchema={Yup.object().shape({
    ondcCategoryId: Yup.string().required("Please select a category type"),
    domain: Yup.string().required("Domain is required"),
    name: Yup.string().required("Name is required"),
    // description: Yup.string().required("Description is required"),
  })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
       console.log("Submitting values:", values);
        try {
          const formattedData = {
            customerId: values.customerId,
            categoryId: categoryInfo?.categoryId,
            name: values.name,
            description: values.description,
            parentCategory: values.parentCategory,
            ondcCategoryId: values.ondcCategoryId,
            domain: values.domain,
          };

          console.log("Formatted data being sent:", formattedData);

          if (isNewCategory) {
            await dispatch(createCategory(addedBy, formattedData, image, bannerImage));
          } else {
            await dispatch(updateCategory(addedBy, formattedData, image, bannerImage));
          }

          setStatus({ success: true });
          setSubmitting(false);
          enqueueSnackbar("Category Created", {
            variant: "success",
          });
          await dispatch(fetchCategory(customerId));
          onSubmitSuccess();
          // navigate("/app/management/category/view");
        } catch (err) {
          // setErrors({ submit: err.message });
          setStatus({ success: false });
          setSubmitting(false);
          enqueueSnackbar("customerId or name Exits", {
            variant: "failure",
          });
        }
      }}
    >
       {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched,
        values,
      }) => (
        <form
          onSubmit={handleSubmit}
          className={clsx(classes.root, className)}
          {...rest}
        >
          <Grid container spacing={3} mt={2}>
            <Grid container item xs={12} ml={2}>
              <Typography>
                {" "}
                Parent Hierarchy :{" "}
                {parentCategoryNames?.length
                  ? parentCategoryNames?.join(" -> ")
                  : "Main Category"}{" "}
              </Typography>
            </Grid>
            <Grid container item xs={12} sm={5}>
              <Grid item xs={12}>
                {!isNewCategory && (
                  <ImageEditor
                    type={IMAGE_TYPE.CATEGORYIMAGE}
                    inImage={imageUrl}
                    customerId={customerId}
                    id={values.categoryId}
                  />
                )}
                {isNewCategory && (
                  <TextField
                    error={Boolean(
                      touched.categoryImage && errors.categoryImage
                    )}
                    fullWidth
                    helperText={touched.categoryImage && errors.categoryImage}
                    type="file"
                    name="categoryImage"
                    onBlur={handleBlur}
                    onChange={handleImage}
                    value={values.image}
                    variant="outlined"
                  />
                )}
    {/* Banner Image */}
    <Box mt={4}>
  <Typography variant="subtitle2" gutterBottom>
    Banner Image
  </Typography>

  {!bannerPreview && (
    <TextField
      fullWidth
      type="file"
      name="bannerImage"
      onChange={handleBannerImage}
      variant="outlined"
      InputLabelProps={{
        shrink: true
      }}
    />
  )}

{bannerPreview && (
  <Box mt={2} textAlign="center">

    <img
      src={bannerPreview}
      alt="Banner Preview"
      style={{
        width: "100%",
        height: "200px",
        objectFit: "cover",
        borderRadius: "8px"
      }}
    />

    <Button
      variant="contained"
      color="error"
      sx={{ mt: 2 }}
      onClick={() => {
        setBannerImage("");
        setBannerPreview("");

        const input = document.querySelector(
          'input[name="bannerImage"]'
        );
        if (input) {
          input.value = "";
        }
      }}
    >
      Remove
    </Button>

  </Box>
)}
</Box>
</Grid>
</Grid>
            <Grid container item spacing={3} xs={12} sm={7}>

              <Grid item xs={12}>
              <Autocomplete
                options={categories || []}
                getOptionLabel={(option) => option?.id || ""}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  return option?.id === value?.id;
                }}
                value={
                  categories?.find(
                    (cat) =>
                      cat?.id === values.ondcCategoryId
                  ) || null
                }
                onChange={(event, value) => {
                  console.log("Selected value:", value);
                  if (value) {
                    const ondcId = value?.id || "";
                    const domainName = value?.name || "";
                    console.log("Setting ondcCategoryId:", ondcId);
                    console.log("Setting domain:", domainName);
                    setFieldValue("ondcCategoryId", ondcId);
                    setFieldValue("domain", domainName);
                     if (isNewCategory) {
                        setFieldValue("name", ondcId);
                        }
                  } else {
                    setFieldValue("ondcCategoryId", "");
                    setFieldValue("domain", "");
                   if (isNewCategory) {
                     setFieldValue("name", "");
                     }
                  }
                }}
                noOptionsText="No categories found"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Category Type"
                    required
                    error={Boolean(touched.ondcCategoryId && errors.ondcCategoryId)}
                    helperText={touched.ondcCategoryId && errors.ondcCategoryId}
                  />
                )}
              />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.categoryId && errors.name)}
                  disabled
                  fullWidth
                  helperText={touched.categoryId && errors.categoryId}
                  label="Category Id"
                  name="categoryId"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.categoryId}
                  variant="outlined"
                />
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                            <TextField
                                error={Boolean(
                                    touched.parentCategory && errors.parentCategory
                                )}
                                fullWidth
                                helperText={
                                    touched.parentCategory && errors.parentCategory
                                }
                                label="Parent Category Id"
                                name="parentCategory"
                                disabled
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.parentCategory}
                                variant="outlined"
                            />
                        </Grid> */}
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.name && errors.name)}
                  fullWidth
                  helperText={touched.name && errors.name}
                  label="Name"
                  name="name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.name}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(touched.description && errors.description)}
                  fullWidth
                  helperText={touched.description && errors.description}
                  label="Description"
                  name="description"
                  multiline
                  rows={3}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.description}
                  variant="outlined"
                />
              </Grid>
           <Grid item xs={12}>

  {errors.submit && (
    <Box mb={2}>
      <FormHelperText error>
        {errors.submit}
      </FormHelperText>
    </Box>
  )}

  <Stack mt={2} spacing={2} direction="row">
    <Button
      color="secondary"
      variant="contained"
      onClick={() => onSubmitCancel()}
    >
      Cancel
    </Button>
    <Button
      color="secondary"
      variant="contained"
      type="submit"
      disabled={isSubmitting}
    >
      Save Category
    </Button>

    {!isNewCategory && (
      <Button
        color="secondary"
        variant="contained"
        onClick={handleDeleteOpen}
      >
        Delete Category
      </Button>
    )}
  </Stack>
  <ConfirmBox
              open={isDeleteOpen}
              closeDialog={() => setDeleteOpen(false)}
              title={"Category: " + values.name + "(" + values.categoryId + ")"}
              deleteFunction={() =>
                handleDeleteCategory(customerId, categoryInfo?.categoryId)
              }
            />
</Grid>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
}

CategoryForm.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default CategoryForm;

